import '../tracer'

import { lazy } from 'react'
import { BrowserRouter, Outlet, Route, Routes } from 'react-router'

import { ToastManager } from '@ui/components/elements/ToastManager/ToastManager'
// import { RouteConfig } from '@ui/interfaces/navigation'
import { AuthProvider } from '@ui/providers/AuthProvider'
import { FeatureFlagProvider } from '@ui/providers/FeatureFlagProvider'
import { SettingsProvider } from '@ui/providers/SettingsProvider'

// import { routesConfig } from '@ui/router/routes'

// const router = createBrowserRouter(
//   routesConfig.map((route: RouteConfig) => route as RouteObject),
//   {
//     future: {
//       v7_relativeSplatPath: true,
//       v7_fetcherPersist: true,
//       v7_normalizeFormMethod: true,
//       v7_partialHydration: true,
//       v7_skipActionErrorRevalidation: true,
//     },
//   }
// )

const AuthRoutes = lazy(() => import('../_auth/AuthRoutes')) // Lazy load the Auth chunk
const AppRoutes = lazy(() => import('../_app/AppRoutes')) // Lazy load the Main chunk

export const AppRouter = () => {
  return (
    <div>
      <AuthProvider>
        <FeatureFlagProvider>
          <SettingsProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Outlet />}>
                  <Route index element={<AuthRoutes />} />
                  <Route path="app" element={<AppRoutes />} />
                </Route>
              </Routes>
            </BrowserRouter>
            {/* <RouterProvider router={router} /> */}
          </SettingsProvider>
        </FeatureFlagProvider>
        <ToastManager />
      </AuthProvider>
    </div>
  )
}
